import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchDeliveryProcess(service_provider_id, delivery_process_id) {
    return RequesterV1.get(
      `service_provider/delivery/managing/${service_provider_id}/show_process/${delivery_process_id}`
    );
  },

  fetchOrder(service_provider_id, delivery_process_id, order_id) {
    return RequesterV1.get(
      `service_provider/delivery/managing/${service_provider_id}/show_order/${delivery_process_id}/${order_id}`
    );
  },
};
